export enum RequestState {
  NotAsked,
  Loading,
  Failure,
  Success,
}
